import React from 'react';
import PropTypes from 'prop-types';
import Button from 'components/Button';
import { formatMoney, isMobile } from 'common/helpers';
import { getPercentage, renderStars } from './helpers';

import { FeaturedHotelDetails as S } from './styles';

class FeaturedDetails extends React.Component {
  renderBookButton = (hotel) => {
    return (
      <a href={hotel.deeplink} target="blank">
        <Button>BOOK WITH DISCOUNT</Button>
      </a>
    );
  }
  renderHotelName = (hotel) => {
    return (
      <div className="first-child">
        <div>
          <h2><a href={hotel.deeplink} target="blank">{hotel.name}</a> &nbsp; {renderStars(5)}</h2>
        </div>
        <p>{hotel.address}</p>
      </div>
    );
  }
  renderHotelPriceMobile = (hotel) => {
    return (
      <div className="last-child">
        <div>
          <h2><small>SWC discount price <br />starting from: <strong>~US${formatMoney(hotel.price, 0)}+</strong></small></h2>
          <div className="thb">
            <div>THB {formatMoney(hotel.notes, 0)}<span className="asterisk">*</span></div>
            <div>SAVE UP TO {getPercentage(hotel.strike_through_price, hotel.price)}%</div>
          </div>
          <h3>Booking.com price: (~US${hotel.strike_through_price}+)</h3>
        </div>
      </div>
    );
  }
  renderHotelPriceWeb = (hotel) => {
    return (
      <div className="last-child">
        <div>
          <h2><small>SWC discount price starting from:</small> <b>THB {formatMoney(hotel.notes, 0)} (~US${formatMoney(hotel.price, 0)}+)<span className="asterisk">*</span></b></h2>
        </div>
        <div className="deals">
          <div className="deal">
            <S.Pill>SAVE UP TO {getPercentage(hotel.strike_through_price, hotel.price)}%</S.Pill>
            <h3>Booking.com price: (~US${hotel.strike_through_price}+)</h3>
          </div>
          <h6>Pricing approximate. You will pay in the hotel&apos;s local currency (THB).</h6>
        </div>
      </div>
    );
  }
  render() {
    const {
      hotel,
    } = this.props;
    return (
      <S.Wrapper>
        {this.renderHotelName(hotel)}
        {!isMobile() ? this.renderHotelPriceWeb(hotel) : this.renderHotelPriceMobile(hotel)}
      </S.Wrapper>
    );
  }
}

FeaturedDetails.propTypes = {
  hotel: PropTypes.object.isRequired,
};

export default FeaturedDetails;



// WEBPACK FOOTER //
// ./src/containers/Hotel/FeaturedDetails.js